import React from "react";
import { Link } from "react-router-dom";
import aboutimage from "../assets/about.png";
import AnimatedSection from "./AnimatedSection";

export default function About() {
  const longText =
    "From going live to building your fan base, we’ve designed every feature to make your streaming journey seamless and rewarding. Host multi‑video streams and interact with your audience in real time through in‑stream chat and interactive games. Create your own private or public rooms to connect with viewers or collaborate with other streamers. Show appreciation through virtual gifting and diamonds, which can be easily withdrawn into real earnings. Join or create agencies to grow your influence, with agents helping you manage events, content, and community engagement. Every part of our platform is built to make streaming not just entertaining—but truly rewarding.";

  const shortText = longText.substring(0, 160) + "...";

  return (
    <section className="px-4 py-24 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-7xl items-center gap-12 rounded-[2rem] border border-white/10 bg-white/5 p-8 shadow-[0_30px_80px_rgba(0,0,0,0.25)] backdrop-blur-xl md:grid-cols-2 lg:p-12">
        <AnimatedSection className="relative" delay={0.05}>
          <div className="absolute -left-4 top-8 h-24 w-24 rounded-full bg-orange-500/20 blur-3xl" />
          <img
            src={aboutimage}
            alt="About Hunt Share Live"
            className="relative mx-auto h-auto w-full max-w-[560px] rounded-[1.5rem] border border-white/10 shadow-2xl shadow-orange-500/10 transition duration-500 hover:scale-[1.02]"
          />
        </AnimatedSection>

        <AnimatedSection className="space-y-6" delay={0.12}>
          <div className="inline-flex rounded-full border border-orange-400/30 bg-orange-500/10 px-4 py-2 text-sm font-medium text-orange-200">
            About the platform
          </div>
          <h2 className="text-3xl font-semibold text-white sm:text-4xl">
            A vibrant ecosystem for creators, communities, and digital rewards.
          </h2>
          <p className="text-lg leading-8 text-slate-300">
            We are passionate about delivering next-level live streaming experiences that are engaging, interactive, and unforgettable. Our platform blends cutting-edge streaming technology with a vibrant community to create a space where creators can shine and viewers can connect in real time.
          </p>
          <p className="text-base leading-8 text-slate-400">{shortText}</p>
          <Link to="/aboutcompany" className="inline-flex rounded-full bg-gradient-to-r from-orange-500 to-fuchsia-600 px-6 py-3 font-semibold text-white shadow-[0_16px_40px_rgba(255,122,61,0.25)] transition hover:scale-[1.02]">
            Read more
          </Link>
        </AnimatedSection>
      </div>
    </section>
  );
}
